import { render, staticRenderFns } from "./query.vue?vue&type=template&id=6c9d765e&scoped=true"
import script from "./query.vue?vue&type=script&lang=ts"
export * from "./query.vue?vue&type=script&lang=ts"
import style0 from "./query.vue?vue&type=style&index=0&id=6c9d765e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d765e",
  null
  
)

export default component.exports